import { render, staticRenderFns } from "./RoleDiv.vue?vue&type=template&id=3c0a016c&scoped=true"
import script from "./RoleDiv.vue?vue&type=script&lang=js"
export * from "./RoleDiv.vue?vue&type=script&lang=js"
import style0 from "./RoleDiv.vue?vue&type=style&index=0&id=3c0a016c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a016c",
  null
  
)

export default component.exports